module.exports = __webpack_public_path__ + "img/lantern-logo.4cbec624.svg";